import { css } from 'react-emotion'

export const NotificationBadgesStyle = css`
  {
    right: -1.5rem;
    border-radius: 50%;
    font-size: 1.4rem !important;
    font-style: normal;
    margin-left: 3px;
    background: #FFBB3B;
    font-style: normal;
    font-weight: 600;
    /* line-height: 12px; */
    color: #343434;
    width: 2rem;
    height: 2rem;
    display: flex !important;
    justify-content: center;
    align-items: center;
    padding: 0 !important;
    .count-number {
      padding: 0;
      display: inline-block;
      font-size: 1.4rem;
    }
  }
`
export const medium = css` {
  width: 2.3rem;
  height: 2.3rem;
}`

export const large = css` {
  width: 3rem;
  height: 2.5rem;
}`